export enum ReportFormsRoutesEnum {
  E8 = 'E8',
  E9 = 'E9',
  Transformator = 'Transformator',
  IntermediateProtection = 'IntermediateProtection',
  SystemController = 'SystemController',
  Eze = 'Eze',
  OfferChecklist = 'Checklist beim Angebot'
}
